const PLATFORMS = [
	{
		id: 'youtube',
		name: 'YouTube',
		url: 'https://youtube.com',
	},
	{
		id: 'instagram',
		name: 'Instagram',
		url: 'https://instagram.com',
	},
	{
		id: 'tiktok',
		name: 'TikTok',
		url: 'https://tiktok.com',
	},
	// {
	//   id: "twitter",
	//   name: "Twitter",
	//   searchArea: "key",
	//   searchKey: "playAddr",
	//   url: "https://twitter.com",
	// },
	// {
	//   id: "x",
	//   name: "Twitter",
	//   url: "https://x.com",
	// },
	// {
	//   id: "linkedin",
	//   name: "LinkedIn",
	//   url: "https://linkedin.com",
	// },
];

export default function getPlatformFromUrl(url: string) {
	return PLATFORMS.find(
		(platform) =>
			url?.startsWith(`https://www.${platform.id}.com`) ||
			url?.startsWith(`https://${platform.id}.com`),
	);
}
